module.exports = __webpack_public_path__ + "img/poplar-mask.c2342005.png";